import Assert from "tbAssert";
const mEventFilterSvc = new WeakMap();

// Exposes the reported date range as the "standard" event range parameter names.
// Adapts EventFilter's reported date range parameters so they can be serviced by an unmodified EventRangeFilter

export default class EventReportedRangeFilterAdapter {
    constructor({eventFilterSvc}) {
        Assert.StrictAssert(eventFilterSvc != null, "event reported range filter adapter missing underlying service parameter");
        mEventFilterSvc.set(this, eventFilterSvc);
    }

    get hasRangeStart() {
        return mEventFilterSvc.get(this).hasReportedRangeStart;
    }

    get rangeStart() {
        return mEventFilterSvc.get(this).reportedRangeStart;
    }
    set rangeStart(val) {
        mEventFilterSvc.get(this).reportedRangeStart = val;
    }

    get hasRangeEnd() {
        return mEventFilterSvc.get(this).hasReportedRangeEnd;
    }

    get rangeEnd() {
        return mEventFilterSvc.get(this).reportedRangeEnd;
    }
    set rangeEnd(val) {
        mEventFilterSvc.get(this).reportedRangeEnd = val;
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/views/event-filter-panel/EventReportedRangeFilterAdapter.js
// module id = rdVw
// module chunks = 1